export function scrollWindowTo(top = 0): void {
  window.scroll({
    top,
    left: 0,
    behavior: 'smooth'
  });
}
